function clickDownloadLink({
  href,
  fileName,
  openInNewTab = false,
}: {
  href: string;
  fileName: string;
  openInNewTab?: boolean;
}) {
  const a = document.createElement('a');
  a.href = href;
  a.download = fileName;
  if (openInNewTab) {
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
  }
  a.click();
}

async function downloadViaBlob(url: string, fileName: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to download attachment: ${response.statusText}`);
  }
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  try {
    clickDownloadLink({ href: blobUrl, fileName });
  } finally {
    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
  }
}

export async function downloadFile(url: string, name: string | undefined) {
  const fileName = name ?? 'attachment';
  try {
    await downloadViaBlob(url, fileName);
  } catch {
    clickDownloadLink({ href: url, fileName, openInNewTab: true });
  }
}
